export default "__VITE_ASSET__C9huy9AO__"